import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import * as Highcharts from 'highcharts';
import { SessionService } from '@tech-services/session.service';
import { highCharts_Languages } from '@tech-helpers/charts/highcharts-languages';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { CommonService } from '@tech-services/common.service';
import { Subject } from 'rxjs';
import {
  PortfolioanalysisSumaryInterface,
  FixedperiodsInterfece,
} from '@techrules/portallib';
import { formatDate, formatPercent, getCurrencySymbol } from '@angular/common';
import { CurrencyPipe } from '@techrules/pipelib';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { takeUntil } from 'rxjs/operators';
import { AppConfig } from '@tech-utils/app-config.service';
import { ModalCustomDateComponent } from '../../../../shared/modal-custom-date/modal-custom-date.component';
import { Utils } from '@tech-utils/utils';
import { TranslateService } from '@ngx-translate/core';
import { TechDialogsService } from '../../../../shared/tech-dialogs.service';

declare const require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);
@Component({
  selector: 'tech-chart-principal',
  templateUrl: './chart-principal.component.html',
  styleUrls: ['./chart-principal.component.scss'],
})
export class ChartPrincipalComponent implements OnInit {
  @Input() portfolioCode: string;
  @ViewChild('menuPeriods', { static: true }) menuPeriods: MatTabGroup;
  @ViewChild('menuPeriodsDiscretePerformace', { static: true }) menuPeriodsDiscretePerformace: MatTabGroup;
  @ViewChild('graficProfilePortfolio', { static: true })
  graficProfilePortfolio: ElementRef;

  private portfolioanalysis: PortfolioanalysisSumaryInterface;
  private options: any;
  private unsubscribe$ = new Subject<void>();
  private selectedPeriod: string = '';

  fixedPeriods: FixedperiodsInterfece[];
  selectDefault: number;
  loadingGraficProfilePortfolio: boolean = true;
  periodInitialDate = '';
  periodEndDate = '';
  minDate: string = '';
  maxDate: string = '';
  chartPercentage = false;
  portfolioCurrency: string = '';
  showPeriodDiscretePerformace: boolean = false;
  periodDiscretePerformace: any = [
    {Name:"k000148", Period:"Annual"},
    {Name:"k002538", Period:"Quarterly"},
    {Name:"k000147", Period:"Monthly"},
    {Period: 'Switch'}
  ];
  selectDefaultDiscretePerformace: number = 0;

  constructor(
    private sessionService: SessionService,
    private profilePortfolioService: ProfileportfolioService,
    private commonService: CommonService,
    private currencyPipe: CurrencyPipe,
    public dialog: MatDialog,
    private translate: TranslateService,
    private dialogService: TechDialogsService,  
  ) {}

  ngOnInit() {
    /*
    Servicio que devuelve los periodos para pintar el gráfico, como han cambiado ahora el orden en que vienen hago un find y un push
    */
    /*  this.commonService.portfolioCode$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((val) => {
        if (Object.entries(val).length !== 0 && val != 'undefined') {
          this.portfolioCode = val;
*/
    this.profilePortfolioService
      .getFixedperiods(this.portfolioCode)
      .subscribe((data) => {
        this.fixedPeriods = [];
        let p1w = data.find((p) => p.Period == 'Period1W');
        if (p1w) this.fixedPeriods.push(p1w);
        let p1m = data.find((p) => p.Period == 'Period1M');
        if (p1m) this.fixedPeriods.push(p1m);
        let p3m = data.find((p) => p.Period == 'Period3M');
        if (p3m) this.fixedPeriods.push(p3m);
        let p1y = data.find((p) => p.Period == 'Period1Y');
        if (p1y) this.fixedPeriods.push(p1y);
        let pytd = data.find((p) => p.Period == 'PeriodYTD');
        if (pytd) this.fixedPeriods.push(pytd);
        let pstartdate = data.find((p) => p.Period == 'PeriodStartDate');
        if (pstartdate) this.fixedPeriods.push(pstartdate);
        let pcustomize = data.find((p) => p.Period == 'PeriodCustom');
        if (pcustomize) this.fixedPeriods.push(pcustomize);

        const periodSwitch = { Period: 'Switch' };

        this.fixedPeriods.push(periodSwitch);

        //this.fixedPeriods = data;
        this.profilePortfolioService.fixedPeriods$.emit(data);
        this.fixedPeriods.forEach((period, ind) => {
          if (period.Period === 'PeriodStartDate') {
            this.menuPeriods.selectedIndex = ind;
            this.selectDefault = ind;
            //this.profilePortfolioService.periodSelectedSource.next(period);
            //this.minDate = period.PeriodInitialtDate;
            this.maxDate = period.PeriodEndDate;
          }
        });
      });
    //}
    // });

    if (this.commonService.isProductiveSource.getValue()) {
      //console.log('A');
      this.profilePortfolioService.periodSelected$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((val) => {
          // console.log('AA');
          if (Object.keys(val).length !== 0) {
            // this.profilePortfolioService.periodSelected = val;
            //console.log('val.periodInitiaDate', val);
            this.periodInitialDate = val.PeriodInitialtDate;
            this.periodEndDate = val.PeriodEndDate;
            if (
              val.Period != 'PeriodCustom' &&
              this.portfolioCode != undefined
            ) {
              this.graficProfilePortfolio.nativeElement.innerHTML = '';
              // this.commonService.isloading(); //Muestra el componente loading-screen
              this.loadingGraficProfilePortfolio = true;
              if (
                val.PeriodInitialtDate != undefined &&
                val.PeriodEndDate != undefined
              ) {
                const jsonPortfolioAnalysis = Utils.formatString(
                  this.jsonPortfolioAnalysis,
                  [this.portfolioCode, val.PeriodInitialtDate, val.PeriodEndDate]
                );
                this.getProfilePortfolio(jsonPortfolioAnalysis);
              }
            }
          }
        });
    } else {
      //console.log('A else');
      this.commonService.isProductive$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((val) => {
          //console.log('A else isproductive$');
          if (Object.keys(val).length !== 0) {
            this.profilePortfolioService.periodSelected$.subscribe((val) => {
              if (Object.keys(val).length !== 0) {
                // this.profilePortfolioService.periodSelected = val;
                //console.log('val.periodInitiaDate', val);
                this.periodInitialDate = val.PeriodInitialtDate;
                this.periodEndDate = val.PeriodEndDate;
                if (val.Period != 'PeriodCustom') {
                  this.graficProfilePortfolio.nativeElement.innerHTML = '';
                  this.commonService.isloading(); //Muestra el componente loading-screen
                  this.loadingGraficProfilePortfolio = true;
                  if (
                    val.PeriodInitialtDate != undefined &&
                    val.PeriodEndDate != undefined
                  ) {
                    const jsonPortfolioAnalysis = Utils.formatString(
                      this.jsonPortfolioAnalysis,
                      [
                        this.portfolioCode,
                        val.PeriodInitialtDate,
                        val.PeriodEndDate,
                      ]
                    );
                    this.getProfilePortfolio(jsonPortfolioAnalysis);
                  }
                }
              }
            });
          }
        });
    }

    this.profilePortfolioService.showPeriodDiscretePerformace$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((val) => {
      this.showPeriodDiscretePerformace = val;
    });
    this.profilePortfolioService.periodDiscretePerformace$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((val) => {
      if(this.chartPercentage && this.profilePortfolioService.portfolioanalysisSource.getValue().ShowProfitLossInClientPortal)
        this.loadGrafDiscretePerformace();
    });
  }

  private jsonPortfolioAnalysis =
    '{"PortfolioCode":"{0}", "InitialDate": "{1}", "EndDate": "{2}", "BenchmarkCodes": [], "Type": "Summary"}';

  private getProfilePortfolio(jsonPortfolioAnalysis: string) {
    this.profilePortfolioService
      .getPortfolioAnalysis(jsonPortfolioAnalysis)
      .subscribe((data) => {
        this.portfolioanalysis = data;
        this.profilePortfolioService.portfolioanalysisSource.next(data);
        this.minDate = data.TotalInitialDate;
        this.getChart();
        this.commonService.isnotloading(); //Oculta el componente loading-screen
        this.loadingGraficProfilePortfolio = false;
        this.portfolioCurrency = getCurrencySymbol(data.Currency, 'wide');
      });
  }

  ngAfterViewInit() {}

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  private getChart() {
    let that = this;
    let currency = this.portfolioanalysis.Currency;
    let language = this.sessionService.language;
    let dateFormat = this.sessionService.dateFormat
      .replace('DD', 'dd')
      .replace('YYYY', 'yyyy')
      .replace('MMM', 'MM');
    let lang =
      this.sessionService.language.substring(0, 2) == 'es'
        ? highCharts_Languages.lang_es_ES
        : highCharts_Languages.lang_en_GB;
    const options: Highcharts.Options = { lang };
    Highcharts.setOptions(options);

    if(this.chartPercentage && this.profilePortfolioService.portfolioanalysisSource.getValue().ShowProfitLossInClientPortal){
      this.profilePortfolioService.showPeriodDiscretePerformaceSource.next(true);
      this.loadGrafDiscretePerformace();
    }else{
      if(this.profilePortfolioService.portfolioanalysisSource.getValue().ShowProfitLossInClientPortal)
        this.profilePortfolioService.showPeriodDiscretePerformaceSource.next(false);
      let xAxis = this.portfolioanalysis.PerformanceIndexes.PortfolioIndex.Dates;
      let yAxiPerformanceOK = [];
      let yAxiValuationsOK = [];
      this.portfolioanalysis.PerformanceIndexes.PortfolioIndex.Dates.forEach(
        (value, key) => {
          yAxiValuationsOK.push(
            this.portfolioanalysis.PerformanceIndexes.PortfolioIndex
              .PortfolioValuations[key]
          );
          if(!this.profilePortfolioService.portfolioanalysisSource.getValue().ShowProfitLossInClientPortal){
            yAxiPerformanceOK.push(
              this.portfolioanalysis.PerformanceIndexes.PortfolioIndex
                .PortfolioPerformances[key] * 100
            );
          }
        }
      );
      let yAxisPerc = this.chartPercentage ? yAxiPerformanceOK : yAxiValuationsOK;
      let yformat = this.chartPercentage ? '{value} %' : '{value}';
      let colorDegrade = this.chartPercentage
        ? this.commonService.colorGrl[0]
        : this.commonService.colorGrl[4];
      let minTickInterval = 70;
      if (xAxis.length > 367) minTickInterval = 200;
      else if (xAxis.length <= 367 && xAxis.length > 93) minTickInterval = 70;
      else if (xAxis.length <= 93 && xAxis.length > 32) minTickInterval = 10;
      else minTickInterval = 1;

      let tickInterval = xAxis.length * 0.2;
      switch (this.selectedPeriod) {
        case 'Period1W':
          tickInterval = 1;
          break;
        case 'Period1M':
          tickInterval = 5;
          break;
        case 'Period3M':
          tickInterval = 10;
          break;

        default:
          tickInterval = xAxis.length * 0.2;
          break;
      }

      let colorForThisGraph = JSON.parse(
        JSON.stringify(this.commonService.colorGrl)
      );
      colorForThisGraph = colorForThisGraph.filter(
        (item) => item !== this.commonService.colorGrl[0]
      );

      let serieType = this.chartPercentage
        ? this.commonService.chartsConfig.chart1.type === 'NO COLOR'
          ? 'line'
          : 'area'
        : this.commonService.chartsConfig.chart2.type === 'NO COLOR'
        ? 'line'
        : 'area';

      let chartConfig = this.chartPercentage
        ? this.commonService.chartsConfig.chart1
        : this.commonService.chartsConfig.chart2;

      let token01;
      this.translate.get('k004381').subscribe((text: string) => {
        token01 = text;
      }); //Token: Evolución Valoración de la cartera
      let token02;
      this.translate.get('k004382').subscribe((text: string) => {
        token02 = text;
      }); //Token: Evolución Rentabilidad de la cartera
      let titlechart = AppConfig.settings.titleOnMainGraph
        ? that.chartPercentage
          ? token02
          : token01
        : '';

      this.options = {
        title: {
          text: titlechart,
        },

        lang: {
          numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'],
        },
        colors: colorForThisGraph,
        chart: {
          height: 400,
          backgroundColor: 'rgba(0,0,0,0)',
          marginRight: 15,
          style: {
            fontFamily: AppConfig.cssVars.fontBase,
          },
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          type: 'datetime',
          //minTickInterval: minTickInterval,
          tickInterval: tickInterval,
          categories: xAxis,
          labels: {
            rotation: 0,
            formatter: function () {
              return formatDate(this.value, dateFormat, language); //formatDate(this.value, 'MMM yyyy', language);
            },
            style: {
              color: this.commonService.colorGrl[3], //Esto es igual a color-04
            },
          },
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            //format: yformat,
            style: {
              color: this.commonService.colorGrl[3], //Esto es igual a color-04
            },
            formatter: function () {
              if (!this.chartPercentage) {
                //Para la minificaion con k (ejemplo 40K para 40 000).
                const valNum = this.value;
                let newValue: string;
                if (valNum >= 1000) {
                  const suffixes = ['', 'K', 'M', 'B', 'T'];
                  // const suffixNum = Math.floor(valNum.toString().length / 3);
                  const suffixNum = Math.floor(
                    Math.floor(Math.log(valNum) / Math.log(1000))
                  );
                  let shortValue: number = 0;
                  for (let precision = 2; precision >= 1; precision--) {
                    shortValue = parseFloat(
                      (suffixNum !== 0
                        ? valNum / Math.pow(1000, suffixNum)
                        : valNum
                      ).toPrecision(precision)
                    );
                    const dotLessShortValue: string = (shortValue + '').replace(
                      /[^a-zA-Z 0-9]+/g,
                      ''
                    );
                    if (dotLessShortValue.length <= 3) {
                      break;
                    }
                  }
                  if (shortValue % 1 !== 0) {
                    shortValue = +shortValue.toFixed(2);
                  }
                  newValue = shortValue + suffixes[suffixNum];
                  return newValue;
                } else {
                  return this.value;
                }
              } else {
                return this.value + ' %';
              }
            },
          },
        },
        tooltip: {
          useHTML: true,
          className: 'charttooltip',
          formatter: function () {
            var s = '';
            s += '<div class="charttooltip">';
            s +=
              '<div class="date">' +
              formatDate(this.x, dateFormat, language) +
              '</div>';
            $.each(this.points, function () {
              if (this.chartPercentage) {
                s +=
                  '<div class"valor">' +
                  formatPercent(this.y / 100, language, '1.2-2') +
                  '</div>';
              } else {
                s +=
                  '<div class"valor">' +
                  that.currencyPipe.transform(this.y, currency, '1.2-2') +
                  '</div>';
              }
            });
            s += '</div>';

            return s;
          },
          shared: true,
          valueDecimals: 2,
          crosshairs: true,
          distance: 20,
          padding: 10,
        },
        plotOptions: {
          series: {
            marker: {
              // Quita los puntos de la grafica <!--style="color: &color-05; font-size: 1.2rem;"-->
              enabled: false,
            },
          },
          area: {
            // color: 'white',
            fillColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1,
              },
              stops: [
                [0, chartConfig.mainColor], ////chartPercentage?'var(--chart1-mainColor)': 'var(--chart2-mainColor)'
                [
                  1,
                  chartConfig.type === 'GRADIENT'
                    ? chartConfig.sencondaryColor //( chartPercentage?'var(--chart1-secondaryColor)': 'var(--chart2-secondaryColor)')//
                    : chartConfig.mainColor, //chartPercentage?'var(--chart1-mainColor)': 'var(--chart2-mainColor)',//
                ],
              ],
            },
            marker: {
              radius: 8,
            },
            lineWidth: 2,
            states: {
              hover: {
                lineWidth: 1,
              },
            },
            threshold: null,
          },
        },
        series: [
          {
            type: serieType,
            name: 'Portfolio',
            color: this.chartPercentage
              ? chartConfig.lineColor
              : chartConfig.lineColor, //'var(--chart1-lineColor)': 'var(--chart2-lineColor)',
            data: yAxisPerc,
            marker: {
              enabled: false, // Quita los puntos de la grafica
            },
          },
        ],
      };
      Highcharts.setOptions({
        lang: { numericSymbols: ['k', 'M', 'G', 'T', 'P', 'E'] },
      });
      Highcharts.chart('graficProfilePortfolio', this.options);
    }
  }

  onTabChangedPeriod(index) {
    if (index === this.fixedPeriods.length - 1) {
      return;
    }

    this.profilePortfolioService.periodSelectedSource.next(
      this.fixedPeriods[index]
    );
    this.selectedPeriod = this.fixedPeriods[index].Period;
  }

  onTabChangedPeriodDiscretePerformace(index) {
    if (index === this.periodDiscretePerformace.length - 1) {
      return;
    }

    this.profilePortfolioService.periodDiscretePerformaceSource.next(
      this.periodDiscretePerformace[index]
    );
    this.selectedPeriod = this.periodDiscretePerformace[index].Period;
  }

  openDialog(PeriodInitialDate, PeriodEndDate) {
    const dialogRef = this.dialog.open(ModalCustomDateComponent, {
      data: {
        initialDate: PeriodInitialDate,
        endDate: PeriodEndDate,
        minDate: this.minDate,
        maxDate: this.maxDate,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let customPeriod = {
          Name: 'Personalizado',
          Period: 'PeriodCustomOK',
          PeriodEndDate: formatDate(result.endDate, 'yyyy-MM-dd', 'en_GR'),
          PeriodInitialtDate: formatDate(
            result.initialDate,
            'yyyy-MM-dd',
            'en_GR'
          ),
        };
        this.profilePortfolioService.periodSelectedSource.next(customPeriod);
      }
    });
  }

  chartSwitchChange(event) {
    this.chartPercentage = event.checked;
    this.getChart();
  }

  loadGrafDiscretePerformace() {
    this.loadingGraficProfilePortfolio = true;
    this.graficProfilePortfolio.nativeElement.innerHTML = '';
    this.profilePortfolioService.getPortfolioDiscretePerformance(localStorage.getItem('PortfolioCode'),'MWR', this.profilePortfolioService.periodDiscretePerformaceSource.value.Period)
    .subscribe((data) => {
      this.loadingGraficProfilePortfolio = false;
      var xAxis = data.map(obj =>obj.Description);
      var yAxis = data.map(obj =>obj.Performance * 100);
      let colorForThisGraph = JSON.parse(
          JSON.stringify(this.commonService.colorGrl)
        );
        colorForThisGraph = colorForThisGraph.filter(
          (item) => item !== this.commonService.colorGrl[0]
        );

      this.options = {
          colors: colorForThisGraph,
          chart: {
              type: 'column',
          },
          credits: {//Para quitar la publi de la web del plugin
              enabled: false
          },
          legend: {
              enabled: false
          },
          title: {
              text: ''
          },
          xAxis: {
              categories: xAxis
          },
          yAxis: {
              title: {
                  text: ''
              },
              labels: {
                  format: '{value} %'
              }
          },
          tooltip: {
              pointFormat: '{point.y} %',
              valueDecimals: 2,
              share: false,
              distance: 30,
              padding: 5
          },
          series: [{
              data: yAxis,
              labels: ''
          }]
      }
      Highcharts.chart('graficProfilePortfolio', this.options);
    })
  }
  public viewHintHelp(event) {
    let text1: string;
    let text2: string;
    this.translate.get('k004407').subscribe((text: string) => {
      text1 = text; //Token: Rentabilidad de la cartera
    });
    this.translate.get('k004408').subscribe((text: string) => {
      text2 = text;
      //Token: El <b>Money-Weighted Return (MWR)</b> mide la rentabilidad de una inversión teniendo en cuenta <b>cuándo y cuánto dinero se ha depositado o retirado</b>. Es decir, refleja <b>el impacto del tiempo y el tamaño de los flujos de efectivo</b> en el rendimiento total de la cartera.
      this.dialogService.openModalDialog('', text1, text2, '');
    });
  }
}
